import React, {Component} from 'react';
import { withRouter } from 'react-router';

import {connect} from 'react-redux';

import { get, isEmpty } from 'lodash';

import Paper from '@material-ui/core/Paper';

import WizardStepper from './WizardStepper';
import WizardPanel from './WizardPanel';
import { Mixpanel } from '../../../helpers/mixpanel';

import * as ArchitectActions from '../../../actions/architectActions';

import classes from './WizardPage.module.css';

const MIXPANEL_EVENT = 'Architect Wizard';

class WizardPage extends Component {
    async componentDidMount() {
        const {
            companyInfo,
            currentUser,
            fetchConversions,
            fetchEquipment,
            history,
            selectedClient,
            selectedSite,
            targetSite
        } = this.props;

        if (isEmpty(targetSite)) {
            history.push(`/architect?company=${companyInfo.companyId}`);

            return;
        }

        const companyId = get(companyInfo, 'companyId', '');
        const siteId = get(selectedSite, 'id', '');

        Mixpanel.track(MIXPANEL_EVENT, {
            company:  companyInfo.companyName,
            userName: `${currentUser.firstName} ${currentUser.lastName}`,
            email:    currentUser.email,
            client:   selectedClient.name,
            site:     selectedSite.name
        });
        
        await fetchConversions(companyId);
        await fetchEquipment(siteId);
    }

    render() {
        const { selectedClient, selectedSite } = this.props;

        if (isEmpty(selectedClient) || isEmpty(selectedSite)) {
            return null;
        }

        return (
            <div className={classes.WizardPage}>
                <div className={classes.stepper}>
                    <Paper className={classes.WizardStepper}>
                        <div className={classes.wizardTitle}>
                            <h1>Architect Wizard</h1>
                            <div className={classes.subtitleContainer}>
                                <span>
                                    {`${selectedClient.name} / ${selectedSite.name}`}
                                </span>
                            </div>
                        </div>
                        <WizardStepper />
                    </Paper>
                </div>
                <div className={classes.wizard}>
                    <WizardPanel selectedSite={selectedSite} />
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        companyInfo:    state.companyInfo,
        currentUser:    state.currentUser,
        selectedClient: state.client.selectedClient,
        selectedSite:   state.site.selectedSite,
        targetSite:     state.wizard.targetSite
    };
};

const mapDispatchToProps = {
    ...ArchitectActions
};

export default withRouter(connect(mapStateToProps,mapDispatchToProps)(WizardPage));
